import {CSSProperties, FC} from 'react';


export interface IIconPersonalLkAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPersonalLkAvito: FC<IIconPersonalLkAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 13 15"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M8.054 8.25c.538 0 .985 0 1.352.029.383.03.736.093 1.076.251a3 3 0 0 1 1.246 1.082c.205.313.318.654.402 1.029.08.36.143.802.22 1.335l.31 2.168a.75.75 0 0 1-.743.856h-10.5a.75.75 0 0 1-.743-.856l.31-2.168c.076-.533.14-.976.22-1.335.083-.375.196-.716.4-1.03a3 3 0 0 1 1.248-1.08c.34-.159.692-.223 1.075-.252.368-.029.814-.029 1.353-.029h2.774ZM6.667 6.75a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75Z" />
        </svg>
    );
};
